import type { OptionType } from '@atlaskit/select';

import type { ContentOption } from '../ContentSourcesPicker';
import type {
	ContentSourcesPickerSearch,
	ContentSourcesPickerSearch_search_nodes_content as SearchContent,
} from '../../../../__types__/ContentSourcesPickerSearchQuery';

// Helper to convert our nullable search results in to concrete ContentOptions
export const getOptionItemsFromQueryData = (data: ContentSourcesPickerSearch): ContentOption[] => {
	const contentOptions: ContentOption[] =
		data.search?.nodes
			?.map((node) => searchContentToOptionType(node?.content))
			.filter(isContentOption) ?? [];
	return contentOptions;
};

// Type guard for ContentOption. Filter undefined and coerce value from OptionType in to a string.
export const isContentOption = (option?: ContentOption | OptionType): option is ContentOption => {
	return (
		option !== undefined && typeof option?.value === 'string' && typeof option?.label === 'string'
	);
};

const searchContentToOptionType = (
	searchContent?: SearchContent | null,
): ContentOption | undefined => {
	if (!searchContent?.title || !searchContent?.id) {
		return undefined;
	}
	return {
		label: searchContent.title,
		value: searchContent.id,
	};
};
